import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormControlComponent } from '@shared/components/base-form-control/base-form-control';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ToggleComponent),
    },
  ],
  selector: 'aux-toggle',
  styles: [],
  templateUrl: './toggle.component.html',
})
export class ToggleComponent extends BaseFormControlComponent<boolean | null> {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter();
  @Input() disabled = false;
  @Input() ngModelOptions?: object;
  @Input() pendoId?: string;

  toggle() {
    this.fc.setValue(!this.fc.value);
    this.onChange(this.fc.value);

    this.change.emit(this.fc.value);
  }

  @Input() set value(value: boolean | null) {
    if (this.fc.value !== value) {
      this.change.emit(value);
    }

    this.fc.setValue(value);
  }

  get value() {
    return !!this.fc.value;
  }
}
